import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

// Lazy load auth pages
const LoginPage = lazy(() => import('@/pages/Login'));
const SignupPage = lazy(() => import('@/pages/Signup'));
const SignupSuccessPage = lazy(() => import('@/pages/Signup/success'));

// Component to redirect from /join to /signup while preserving URL parameters
const JoinRedirect = () => {
  const location = useLocation();
  // Preserve search params and hash
  const destination = `/signup${location.search}${location.hash}`;
  return <Navigate to={destination} replace />;
};

const PageLoader = () => (
  <div className="flex min-h-screen items-center justify-center">
    <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-gray-900"></div>
  </div>
);

export const AuthRoutes = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/signup/success" element={<SignupSuccessPage />} />
        <Route path="/join" element={<JoinRedirect />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Suspense>
  );
};
